import React, { useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import qmsDocumentTypeActions from "../../../_actions/_qmsActions/qmsDocumentTypeActions";
import QmsAdminModal_EditDocumentType from "./QmsAdminModal_EditDocumentType";
import { QmsDataTable } from "../_common/QmsDataTable";

export default function QmsAdminDocumentTypes(props) {
  const { divisionId } = props;

  const columns = useRef([
    {
      id: "label",
      numeric: false,
      disablePadding: true,
      label: "Document Type",
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
    },
  ]);

  const dispatch = useDispatch();
  useEffect(() => dispatch(qmsDocumentTypeActions.getAll(divisionId)), [divisionId]);

  const qmsDocumentTypes = useSelector(
    (state) => state.qms.qmsDocumentTypes[divisionId] || null
  );

  return (
    <QmsDataTable
      data={qmsDocumentTypes}
      columns={columns.current}
      idName="qmsDocumentTypeId"
      editModalComponent={<QmsAdminModal_EditDocumentType divisionId={divisionId} />}
      onDelete={(ids) => dispatch(qmsDocumentTypeActions.removeRange(ids, divisionId))}
      isExpandable={false}
    />
  );
}
